import { Fee } from "./Fee";
export class Fees {
    _fees = [];
    constructor(fees = []) {
        this.fees = fees;
        this.updateJsValues();
    }
    updateModelValues() {
        this._fees.forEach((bm) => bm.updateModelValues());
    }
    updateJsValues() {
        this._fees.forEach((bm) => bm.updateJsValues());
    }
    get fees() {
        return this._fees;
    }
    set fees(value) {
        // check type and inflate if necessary
        this._fees = value.map((c) => {
            if (c instanceof Fee) {
                return c;
            }
            return new Fee(c);
        });
    }
    get all() {
        return this._fees;
    }
    get active() {
        return this._fees.filter((f) => f.active);
    }
    deactivateAll() {
        this._fees.forEach((f) => (f.active = false));
    }
    activateAll() {
        this._fees.forEach((f) => (f.active = true));
    }
    addFee(fee) {
        // check if fee is of correct type otherwise inflate
        if (!(fee instanceof Fee)) {
            fee = new Fee(fee);
        }
        this._fees.push(fee);
    }
    removeFeeAtIndex(index) {
        this._fees.splice(index, 1);
    }
    get length() {
        return this._fees.length;
    }
    atIndex(index) {
        return this._fees[index];
    }
    get first() {
        return this._fees[0];
    }
    get last() {
        return this._fees[this._fees.length - 1];
    }
    get json() {
        return this._fees.map((bm) => bm.json);
    }
}
